import React, { useContext, useEffect, useState } from "react";

import { OutcomeQuizQuestionContent } from "../../../graphql/queries/games/outcome-quiz.js";
import MediaItem from "../../gallery/_common/MediaItem.js";
import { gaTrackOutcomeQuizEvent } from "../../../helpers/googleAnalytics.js";
import { Content } from "../../layout/CommonContentContextProvider.js";
import VariantIcon from "../quiz/VariantIcon.js";
import {
    answerImageContainer,
    mediaItemWrapper,
    pickedOutcomeVariantButton,
    shownAnswerImageContainer,
    stageNumber,
    title,
    variantButton,
    variantButtonText,
    variants,
} from "../quiz/Question.css.js";

interface Props {
    question: OutcomeQuizQuestionContent;
    outcomeQuizId: string;
    stage: number;
    fullStage: string;
    onPickHandler: (variantId: string, summaryWeights: number[]) => void;
    onNextHandler: () => void;
}

const OutcomeQuizQuestion: React.FC<Props> = ({
    question,
    stage,
    fullStage,
    outcomeQuizId,
    onPickHandler,
    onNextHandler,
}) => {
    const { langCode } = useContext(Content);
    const [answered, setAnswered] = useState<string | null>(null);

    useEffect(() => {
        gaTrackOutcomeQuizEvent(
            "ShowQuestionID",
            outcomeQuizId,
            langCode,
            question.id,
        );
        gaTrackOutcomeQuizEvent(
            "ShowStage",
            outcomeQuizId,
            langCode,
            `${stage}`,
        );
    }, [outcomeQuizId, question, stage]);

    return (
        <>
            <div className={stageNumber}>{fullStage}</div>
            <h1 className={title}>{question.text}</h1>
            <div className={mediaItemWrapper}>
                <MediaItem
                    mediaItem={question.image}
                    showPlaceholder={false}
                    srcSetSizes={{
                        tablet: 614,
                    }}
                />
                {question.answerImage && (
                    <div
                        className={
                            answered === null
                                ? answerImageContainer
                                : shownAnswerImageContainer
                        }
                    >
                        <MediaItem
                            mediaItem={question.answerImage}
                            showPlaceholder={false}
                            srcSetSizes={{
                                tablet: 614,
                            }}
                        />
                    </div>
                )}
            </div>

            <div className={variants}>
                {question.variants.map(({ id, text, summaryWeights }) => (
                    <button
                        className={
                            answered === id
                                ? pickedOutcomeVariantButton
                                : variantButton
                        }
                        key={`${question.id}${id}`}
                        onClick={() => {
                            onPickHandler(id, summaryWeights);
                            setAnswered(id);
                            setTimeout(onNextHandler, 1200);
                        }}
                        disabled={answered !== null}
                    >
                        <VariantIcon
                            state={answered == id ? "picked" : "empty"}
                        />
                        <span className={variantButtonText}>{text}</span>
                    </button>
                ))}
            </div>
        </>
    );
};

export default OutcomeQuizQuestion;
